import * as React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { CashLot } from '../api/cash-lot';
import { getAggregatedCashLotItems } from './shared';

interface ForecastToActualProps {
  cashLot: CashLot;
  frequency: string;
}

interface ForecastToActualItem {
  inblockActual: number;
  inblockForecast: number;
  dateUnit: string;
}

const getForecastToActualItems = (cashLot: CashLot, frequency: string): ForecastToActualItem[] => {  
  const aggregatedItems = getAggregatedCashLotItems(cashLot.items.filter(x => x.source === 'AR'), frequency);
  const forecastItems: ForecastToActualItem[] = [];

  for (let aggregatedItem of aggregatedItems) {
    let forecastInvoiceAmount = 0; 
    let actualPaymentAmount = 0; 

    for (let invoiceItem of aggregatedItem.items.filter(x => x.type==='Invoice')) {
      forecastInvoiceAmount += invoiceItem.amount;
    }

    for (let paymentItem of aggregatedItem.items.filter(x => x.type==='Payment')) {
      actualPaymentAmount += paymentItem.amount;
    }

    forecastItems.push({
      inblockActual: actualPaymentAmount,
      inblockForecast: forecastInvoiceAmount,
      dateUnit: aggregatedItem.dateUnit
    })
  }

  return forecastItems;
};

const getHighchartOptions = (items: ForecastToActualItem[]): Highcharts.Options => {
  return {
    chart: {
      height: 300,
      width: 1000
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: items.map(x => x.dateUnit)
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    colors: ['#3fb1e3', '#3893be', '#2e6586'],
    legend: {
      symbolWidth: 40
    },
    tooltip: {
      valueDecimals: 2      
    },
    series: [
      {
        type: 'line',
        name: 'InBlock Actual',
        data: items.map(x => x.inblockActual)
      },
      {
        type: 'line',
        name: 'InBlock Forecast',
        data: items.map(x => x.inblockForecast),
        dashStyle: 'ShortDash'
      }
    ],
    credits:{
      enabled: false
    }
  }
};

export const ForecastToActual = ({ cashLot, frequency }: ForecastToActualProps) => {
  const items = React.useMemo(() => getForecastToActualItems(cashLot, frequency), [cashLot.items['_changeToken'], frequency]);

  const options = getHighchartOptions(items);

  return (
    <HighchartsReact highcharts={Highcharts} options={options} />
  );
};
